import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/hooks/useAuth";
import { ToastProvider } from "@/components/feature/Toast";
import { CartProvider } from "@/hooks/useCart";
import { ChristmasThemeProvider } from "@/hooks/useChristmasTheme";
import ChristmasSnow from "@/components/feature/ChristmasSnow";
import ChristmasGreeting from "@/components/feature/ChristmasGreeting";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ChristmasThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <CartProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
              </BrowserRouter>
            </CartProvider>
          </ToastProvider>
        </AuthProvider>
        <ChristmasSnow />
        <ChristmasGreeting />
      </ChristmasThemeProvider>
    </I18nextProvider>
  );
}

export default App;